import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["as", "children"],
    _excluded2 = ["theme", "$styles", "$align"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import styled from 'styled-components';
import { convertLayoutProps } from '../../utils';
import { jsx as _jsx } from "react/jsx-runtime";
var HeadingElement = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _props$as = props.as,
      Element = _props$as === void 0 ? 'div' : _props$as,
      children = props.children,
      restProps = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/_jsx(Element, _objectSpread(_objectSpread({
    ref: ref
  }, restProps), {}, {
    children: children
  }));
});
HeadingElement.displayName = 'HeadingElement';
var HeadingBase = styled(HeadingElement).withConfig({
  displayName: "Heading__HeadingBase",
  componentId: "sc-b3bfv6-0"
})(["font-family:var(--wcds-font-primary);font-weight:var(--wcds-legacy-heading-base-font-weight);font-feature-settings:var(--wcds-header-font-feature-settings);overflow-wrap:break-word;word-wrap:break-word;body:lang(ja) &{font-family:", ";font-feature-settings:normal;}body:lang(ru) &{font-family:var(--wcds-font-secondary);font-feature-settings:'ss03';}"], function (_ref) {
  var theme = _ref.theme;
  return theme.fonts.mPlus1;
});
HeadingBase.displayName = 'HeadingBase';
var Heading = styled(HeadingBase).withConfig({
  displayName: "Heading",
  componentId: "sc-b3bfv6-1"
})(["color:", ";", ";", ""], function (_ref2) {
  var theme = _ref2.theme,
      _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? 'primaryIndigo' : _ref2$color;
  return theme.colors[color];
}, function (_ref3) {
  var theme = _ref3.theme,
      $styles = _ref3.$styles,
      $align = _ref3.$align,
      props = _objectWithoutProperties(_ref3, _excluded2);

  return theme.normalizeStyles(_objectSpread(_objectSpread({}, convertLayoutProps(props)), {}, {
    textAlign: $align
  }, $styles));
}, function (_ref4) {
  var theme = _ref4.theme,
      $variant = _ref4.$variant;
  return $variant && theme.expandVariants($variant, theme.typography.heading);
});
Heading.displayName = 'Heading';
export default Heading;